import momentTZ from "moment-timezone";

export const TimezoneList = momentTZ.tz
  .names()
  .map((each) => {
    return {
      name: each,
      timezone: momentTZ.tz(each).format("Z"),
      offset: momentTZ.tz(each).utcOffset(),
    };
  })
  .filter((each) => -400 < each.offset && each.offset < 400)
  .sort((a, b) => b.offset - a.offset);
